export const categories = [
  { value: 'Yoga', label: 'Yoga' },
  { value: 'Meditation', label: 'Meditation' },
  { value: 'Nutrition', label: 'Nutrition' },
  { value: 'Acupuncture', label: 'Acupuncture' },
  { value: 'Massage', label: 'Massage Therapy' },
  { value: 'Personal_Training', label: 'Personal Training' },
  { value: 'Psychotherapy', label: 'Psychotherapy' },
  { value: 'Pilates', label: 'Pilates' },
];

export const workArrangements = [
  { value: 'In_Person', label: 'In Person' },
  { value: 'Online', label: 'Online' },
  { value: 'Hybrid', label: 'In Person & Online' },
];

export const languages = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'it', label: 'Italian' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'nl', label: 'Dutch' },
  { value: 'ja', label: 'Japanese' },
  { value: 'zh', label: 'Chinese' },
];